export interface UtmData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

export function getUtmFromCookie(): UtmData | null {
  const cookies = Object.fromEntries(
    document.cookie
      .split('; ')
      .filter(Boolean)
      .map((c) => {
        const [key, ...rest] = c.split('=');
        return [key, rest.join('=')];
      }),
  );

  if (!cookies['utm_data']) return null;

  try {
    return JSON.parse(decodeURIComponent(cookies['utm_data'])) as UtmData;
  } catch {
    return null;
  }
}
